// extracted by mini-css-extract-plugin
export default {"char":"Emoji-module__char--jafDD","small":"Emoji-module__small--NlPeK","large":"Emoji-module__large--seayr"};